export default __webpack_public_path__ + "static/media/sell2.1fc5b891.svg";